import { CircledQuestion } from './Icons';

/**
 * The "Learn More" link that opens a column selector's help modal.
 *
 * Contentstack decides where the link lives, so this renders only when the
 * configured position matches the slot it was dropped into.
 *
 * @param helpModal From `useVariantHelpModal()`
 * @param position The slot this instance occupies: 'Top Right' or 'Bottom Left'
 */
export default function HelpModalLink({ helpModal, position, className = '' }) {
  const { hasModal, linkLabel, linkPosition, show } = helpModal;

  if (!hasModal || linkPosition !== position) {
    return null;
  }

  if (position === 'Top Right') {
    return (
      <button
        type="button"
        className="body-xs text-dawn-grey-30 cursor-pointer underline"
        onClick={show}
      >
        {linkLabel}
      </button>
    );
  }

  return (
    <button
      className={`body-s flex cursor-pointer text-white ${className}`}
      onClick={show}
    >
      <CircledQuestion />
      <span className="ml-2 underline">{linkLabel}</span>
    </button>
  );
}
